
<template>
  <div class="home-card-2">
    <div class="search-container">

      <GlobalSearch style="margin-bottom: 20px;" class="search" />
    </div>

    <h2 style="font-size: 16px; color: rgb(73, 80, 87)">
      <span>MY RECENT DRAFT SLIDES</span>
    </h2>
    <div class="recents-panel" style="font-size: 14px;">
      <DataView :value="recents">
        <template #list="slotProps">
          <div class="flex flex-col">
            <div v-for="(item, index) in slotProps.items" :key="index">
              <RouterLink :to="{ name: 'editor', query: { id: item.content.slideId, vmId: item.content.valueModelId } }">
                    <div class="bg-surface-100 p-1" style="border-radius: 10px">
                      <div class="route bg-surface-0 flex items-center gap-2 justify-center py-1 px-2" style="border-radius: 10px; border: 1px solid #dfe1e6; background-color: #ffff; box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.04), 0px 1px 2px 0px rgba(0, 0, 0, 0.06)">
                          <div>{{ item.content.slideName }}</div>
                          <div style="font-size: 12px; color: #757575;">Last Modified by: {{ item.content.author.name}} on {{getReadableDate(item.content.updated)}}</div>
                    </div>
                  </div>
              </RouterLink>
                </div>
          </div>
        </template>
        <template #empty>
          <div v-if="isLoading">
            <div class="card flex justify-center">
              <ProgressSpinner style="width: 30px; height: 30px" strokeWidth="6" fill="transparent"
                               animationDuration="1s" aria-label="Custom ProgressSpinner" />
            </div>
          </div>
          <div v-else>No results</div>
        </template>
      </DataView>

    </div>
    <div class="feed-panel" style="font-size: 14px;">
      <div>Feed of others activities here</div>
    </div>
  </div>
</template>

<script setup lang="ts">

import GlobalSearch from "@/views/Dashboard/components/GlobalSearch.vue";
import { useAuthStore} from '@/store'
import {storeToRefs} from "pinia";
import axios from "axios";
import { onMounted, ref } from "vue";


const authStore = useAuthStore()
const { loggedInUser } = storeToRefs(authStore)
const recents = ref([])
const isLoading = ref(false)

onMounted(async () => {

  recents.value = await getRecentlyViewed()
  isLoading.value = false
})



const getReadableDate = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
const getRecentlyViewed = async () => {
  const endpoint = `${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/recents-service?user=${loggedInUser.value.email}`;

  try {
    isLoading.value = true
    const response = await axios.get(endpoint);
    return response.data
  } catch (error) {
    console.error("Error getting authors:", error);
  }


}
</script>

<style scoped lang="scss">

.home-card-2 {
  width: 100%;

  .search-container {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 20px;
  }

  .recents-panel {
    grid-column: 1 / span 1;
    grid-row: 1 / span 1;
    margin-bottom: 24px;
    width: 100%;
  }

  .feed-panel {
    grid-column: 1 / span 1;
    grid-row: 2 / span 1;
    width: 100%;
  }
}


:deep(.p-dataview .p-dataview-content) {
  background-color: transparent;

}

.route:hover {
  background-color: #f0f0f0 !important;
  cursor: pointer !important;
}

:deep(.card) {
  background-color: transparent;
  border: none;
}

</style>